import React from 'react';
import { Star, Quote, ThumbsUp } from 'lucide-react';
import { reviews } from '../data/mock';

const Reviews = () => {
  return (
    <section id="reviews" className="py-20 bg-bg-page">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-brand-primary/10 border border-brand-primary/30 rounded-full px-4 py-2 mb-6">
            <span className="text-brand-dark text-sm font-semibold">
              Customer Reviews
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
            What Our Customers Say
          </h2>
          <p className="text-text-secondary text-lg leading-relaxed">
            Don't just take our word for it. See what our satisfied customers
            have to say about our services.
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-bg-card rounded-[32px] p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-brand-primary/20">
                <Quote size={48} />
              </div>

              {/* Star Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="text-yellow-500 fill-yellow-500"
                    size={20}
                  />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-text-secondary leading-relaxed mb-6 relative z-10">
                "{review.text}"
              </p>

              {/* Reviewer Info */}
              <div className="flex items-center justify-between pt-6 border-t border-border-light">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-brand-dark rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-lg">
                      {review.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="font-semibold text-text-primary">
                      {review.name}
                    </p>
                    {review.recommends && (
                      <p className="text-brand-dark text-sm font-medium flex items-center gap-1">
                        <ThumbsUp size={14} />
                        Recommends
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Banner */}
        <div className="mt-16 bg-brand-dark rounded-[32px] p-8 md:p-12 text-center">
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
            <div>
              <p className="text-brand-primary text-4xl md:text-5xl font-bold mb-2">
                5.0
              </p>
              <p className="text-white/70">Average Rating</p>
            </div>
            <div className="w-px h-16 bg-white/20 hidden md:block" />
            <div>
              <p className="text-brand-primary text-4xl md:text-5xl font-bold mb-2">
                100%
              </p>
              <p className="text-white/70">Recommend Us</p>
            </div>
            <div className="w-px h-16 bg-white/20 hidden md:block" />
            <div>
              <p className="text-brand-primary text-4xl md:text-5xl font-bold mb-2">
                100+
              </p>
              <p className="text-white/70">Projects Completed</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
